import { AppConfig } from 'src/models';
import { api, Language } from 'src/services';
import { AxiosPromise } from 'axios';
import { getAPiVersion } from '.';

/**
 * Get App Config
 */
export type AppConfigApiPayload = {
  chatToken: string;
};

export type AppConfigApiResponse = AppConfig;

export const getAppConfigApi = ({
  chatToken,
}: AppConfigApiPayload): AxiosPromise<AppConfigApiResponse> => {
  return api.get<AppConfigApiResponse>('/v3/config', {
    headers: {
      'Chat-URL': chatToken ? `/${chatToken}` : '/',
    },
  });
};

/**
 * Get faq
 */
export type FaqResponse = {
  body: string;
  faq_id: number;
  language: string;
  org_id: number;
  title: string;
};

export type GetFaqApiPayload = {
  chatToken: string;
};

export type GetFaqApiResponse = { FAQs: FaqResponse };

export const getFaqApi = ({
  chatToken,
}: GetFaqApiPayload): AxiosPromise<GetFaqApiResponse> => {
  const apiVersion = getAPiVersion();

  if (apiVersion === 'v3') {
    return api.get<GetFaqApiResponse>('/v3/faq');
  }

  return api.post('/faq', {
    access_token: chatToken,
  });
};

export type UpdatePreferredLanguageApiPayload = {
  languageCode: Language;
};

export const updatePreferredLanguageApi = (
  payload: UpdatePreferredLanguageApiPayload
): AxiosPromise<void> => {
  const apiVersion = getAPiVersion();

  if (apiVersion === 'v3') {
    return api.put('/v3/patient/preferred-language', {
      language_code: payload.languageCode,
    });
  }

  return api.put('/v2/patient/preferred-language', {
    language_code: payload.languageCode,
  });
};
